<template>
    <div class="cs-saved-modal">
        <div class="cs-modal-header">
            <h3>Saved Indicators</h3>
            <div class="cs-modal-actions">
                <button class="cs-import-btn" @click="$emit('import')">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
                        <polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>
                    </svg>
                    Import JSON
                </button>
                <button class="cs-close-btn" @click="$emit('close')">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                    </svg>
                </button>
            </div>
        </div>

        <div class="cs-saved-list">
            <div v-if="!indicators.length" class="cs-empty-state">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" opacity="0.3">
                    <path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z"/>
                </svg>
                <p>No saved indicators yet.</p>
                <p class="cs-hint">Create an indicator and it will be auto-saved here.</p>
            </div>

            <div
                v-for="ind in indicators"
                :key="ind.id"
                class="cs-saved-card"
                @click="$emit('select', ind)"
            >
                <div class="cs-saved-info">
                    <div class="cs-saved-name">{{ ind.name }}</div>
                    <div class="cs-saved-meta">
                        <span class="cs-saved-badge" :class="'cs-badge-' + (ind.category || 'custom')">
                            {{ ind.category || 'custom' }}
                        </span>
                        <span>{{ ind.side === 'onchart' ? 'Overlay' : 'Pane' }}</span>
                        <span>{{ formatDate(ind.updatedAt) }}</span>
                    </div>
                </div>
                <button class="cs-delete-btn" @click.stop="onDelete(ind.id)" title="Delete">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="3 6 5 6 21 6"/>
                        <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/>
                    </svg>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { loadAllIndicators } from '../../candle-script/storage.js';

export default {
    name: 'SavedIndicators',
    data() {
        return {
            indicators: [],
        };
    },
    created() {
        this.indicators = loadAllIndicators();
    },
    methods: {
        onDelete(id) {
            this.$emit('delete', id);
            this.indicators = this.indicators.filter(i => i.id !== id);
        },
        formatDate(ts) {
            if (!ts) return '';
            const d = new Date(ts);
            return d.toLocaleDateString() + ' ' + d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        },
    },
};
</script>

<style scoped>
.cs-saved-modal {
    background: var(--tc-bg-elevated, #fff);
    border-radius: 12px;
    box-shadow: var(--tc-shadow-lg, 0 8px 30px rgba(0,0,0,0.12));
    width: 480px;
    max-height: 70vh;
    overflow-y: auto;
}

.cs-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid var(--tc-border-primary, #e0e3eb);
}

.cs-modal-header h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: var(--tc-text-primary, #131722);
}

.cs-modal-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.cs-import-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    background: none;
    border: 1px solid var(--tc-border-primary, #e0e3eb);
    border-radius: 6px;
    padding: 6px 12px;
    font-size: 12px;
    color: var(--tc-text-secondary, #787b86);
    cursor: pointer;
    transition: all 0.15s;
}
.cs-import-btn:hover {
    border-color: var(--tc-accent, #2962ff);
    color: var(--tc-accent, #2962ff);
}

.cs-close-btn {
    background: none;
    border: none;
    color: var(--tc-text-secondary, #787b86);
    cursor: pointer;
    padding: 4px;
    border-radius: 6px;
}
.cs-close-btn:hover {
    background: var(--tc-bg-hover, rgba(0,0,0,0.04));
}

.cs-saved-list {
    padding: 12px;
}

.cs-empty-state {
    text-align: center;
    padding: 32px;
    color: var(--tc-text-tertiary, #9ca3af);
    font-size: 13px;
}
.cs-hint {
    font-size: 12px;
    margin-top: 4px;
}

.cs-saved-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 14px;
    border: 1px solid var(--tc-border-primary, #e0e3eb);
    border-radius: 8px;
    margin-bottom: 8px;
    cursor: pointer;
    transition: all 0.15s;
}
.cs-saved-card:hover {
    border-color: var(--tc-accent, #2962ff);
    background: var(--tc-accent-bg, rgba(41,98,255,0.04));
}

.cs-saved-name {
    font-size: 14px;
    font-weight: 500;
    color: var(--tc-text-primary, #131722);
    margin-bottom: 4px;
}

.cs-saved-meta {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 11px;
    color: var(--tc-text-tertiary, #9ca3af);
}

.cs-saved-badge {
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    padding: 1px 6px;
    border-radius: 3px;
}
.cs-badge-trend { background: rgba(41,98,255,0.1); color: #2962ff; }
.cs-badge-oscillator { background: rgba(126,87,194,0.1); color: #7e57c2; }
.cs-badge-volatility { background: rgba(255,109,0,0.1); color: #ff6d00; }
.cs-badge-custom { background: rgba(38,166,154,0.1); color: #26a69a; }

.cs-delete-btn {
    background: none;
    border: none;
    color: var(--tc-text-tertiary, #9ca3af);
    cursor: pointer;
    padding: 6px;
    border-radius: 6px;
    transition: all 0.15s;
}
.cs-delete-btn:hover {
    color: var(--tc-red, #ef4444);
    background: var(--tc-red-bg, rgba(239,68,68,0.1));
}
</style>
